import { DatePickerI18n } from "@wk/components-v3-angular17";

export class WkDateFormat {
    private static readonly DATE_REGEXP: RegExp = /^(?<year>\d{4})-(?<month>0[1-9]|1[0-2])-(?<day>0[1-9]|[12][0-9]|3[01])$/;

    private static readonly frenchI18n: DatePickerI18n = {
        calendar: {
            dayNames: [
                { shortName: "Lu", srName: "Lundi" },
                { shortName: "Ma", srName: "Mardi" },
                { shortName: "Me", srName: "Mercredi" },
                { shortName: "Je", srName: "Jeudi" },
                { shortName: "Ve", srName: "Vendredi" },
                { shortName: "Sa", srName: "Samedi" },
                { shortName: "Di", srName: "Dimanche" },
            ],
            monthNames: [
                { shortName: "jan", fullName: "janvier" },
                { shortName: "fév", fullName: "février" },
                { shortName: "mar", fullName: "mars" },
                { shortName: "avr", fullName: "avril" },
                { shortName: "mai", fullName: "mai" },
                { shortName: "jun", fullName: "juin" },
                { shortName: "jui", fullName: "juillet" },
                { shortName: "aoû", fullName: "août" },
                { shortName: "sep", fullName: "septembre" },
                { shortName: "oct", fullName: "octobre" },
                { shortName: "nov", fullName: "novembre" },
                { shortName: "déc", fullName: "décembre" },
            ],
            chooseMonth: "Appuyez pour choisir un mois",
            chooseYear: "Appuyez pour choisir une année",
            nextMonth: "Mois prochain",
            previousMonth: "Mois précédent",
            nextYear: "Année prochaine",
            previousYear: "Année précédente",
            next12Years: "Les 12 prochaines années",
            previous12Years: "Les 12 précédentes années",
        },
        inputField: {
            srClearInputLabel: "Entrée claire",
        },
    };

    public static readonly getDatePickerI18n = (language: string): DatePickerI18n | undefined => {
        return language === "fr-CA" ? WkDateFormat.frenchI18n : undefined;
    };

    public static readonly formatDateFn = (date: Date): string => {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
    };

    public static readonly formatDate = (date: string): Date | null | undefined => {
        if (!date) return null;
        return new Date(date);
    };

    public static parseDateFn = (
        value: string,
    ): {
        month: number;
        day: number;
        year: number;
    } => {
        const [year, month, day] = value.split("-").map((str: string) => Number.parseInt(str));
        return {
            month,
            day,
            year,
        };
    };

    public static validateDateStringFn = (value: string): boolean => {
        const match: any = value?.length && value.match(WkDateFormat.DATE_REGEXP)?.groups;
        if (!match) return false;
        const day: number = Number.parseInt(match.day);
        const month: number = Number.parseInt(match.month);
        const year: number = Number.parseInt(match.year);
        const date: Date = new Date(year, month - 1, day);
        return day === date.getDate() && month === date.getMonth() + 1 && year === date.getFullYear();
    };

    public static readonly toYYYYMMDD = (text: string): string => {
        const date = WkDateFormat.formatDate(text);
        if (!date || Number.isNaN(date.getTime())) return "";
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
    };

    public static readonly toStartOfDayEpochSeconds = (text: string): number | null => {
        const date = WkDateFormat.formatDate(text);
        if (!date || Number.isNaN(date.getTime())) return null;
        return Math.floor(new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime() / 1000);
    };

    public static readonly toEndOfDayEpochSeconds = (text: string): number | null => {
        const date = WkDateFormat.formatDate(text);
        if (!date || Number.isNaN(date.getTime())) return null;
        return Math.floor(new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999).getTime() / 1000);
    };
}
